export default {
  evaluation_dashboard: {
    title: '委託評估數據儀表板',
    unit: ' 公司',
    average: '平均:',
    point: ' 分',
    answered_label: '已回覆',
    evaluated_label: '完成評估',
    corporate_average: '委託評估企業的平均',
    points_earned_by_companies: '委託評估企業的得分分布',
    year_modal: {
      title: '請選擇對象年度。',
      label: '對象年度',
    },
    response_status_title: '回答狀態分布',
    response_status_rating_nothing: '沒有已完成ESG評級評估的企業。',
    esg_rating_title: 'ESG評級分布',
    esg_score_title: 'ESG評分的分布',
    category_scores_title: '按類別評分比較',
    category_scores_distribution_title: '按類別評分分布',
    category_score_data_all_label: 'ASUENE ESG整體平均',
    esg_scores_by_industry_title: '各業種的ESG評分分布',
    environment_score_title: '環境評分分布',
    social_score_title: '社會評分分布',
    governance_score_title: '治理評分分布',
    environment_score_subtitle_upper5: '環境評分 前5名公司',
    environment_score_subtitle_lower5: '環境評分 倒數5名公司',
    social_score_subtitle_upper5: '社會評分 前5名公司',
    social_score_subtitle_lower5: '社會評分 倒數5名公司',
    governance_score_subtitle_upper5: '治理評分 前5名公司',
    governance_score_subtitle_lower5: '治理評分 倒數5名公司',
    // empty_error_message: "",
    common: {
      companies: ' 公司',
      update_date: '更新日期時間',
    },
    registration_rate: {
      title: '登錄率',
      tip: '調查對象公司數當中，登錄於ASUENE ESG的受評企業數所占比例',
    },
    answer_rate: {
      title: '回答率',
      tip: '調查對象公司數當中，有提交回答的受評企業數所占比例',
    },
    days_remaining: {
      title: '調查結束倒數天數',
      tip: '設定的回答期限倒數天數。\n欲變更回答期限時，請聯絡我們。',
      days_remaining_before: '剩餘',
      days_remaining_after: '天',
      expired: '已過回答期限',
    },
    answer_transition: {
      title: '回答變化',
      companies_submitted: '回答公司數',
      breakdown: '詳細',
      unregistered: '未登錄',
      total: '共',
      number_of_companies: '公司數',
    },
    answer_list: {
      title: '最新回答資料',
      submitted_at: '回答日',
    },
  },
}
